import { Tabs } from '../../../shared/js/modules/tabs';
import { lang } from '../../../shared/js/globals/language';
import { initConsentOverlays } from '../../molecules/consent-overlay/consent-overlay';
// import { Slider } from '../../atoms/slider/slider';
import Bus from '../../../shared/js/modules/event-bus';
import { Lightbox } from '@3pc/lightbox-photoswipe';
import { config, fixCounter } from '../../atoms/lightbox/lightbox';

const timelineInstances = [];
const tabsInstances = [];
const labels = {
  de: {
    loading: 'Inhalte werden geladen …',
  },
  en: {
    loading: 'Loading content …',
  },
};
const initTimelines = async () => {
  const timelines = document.querySelectorAll('.timeline');

  if (!timelines.length) return;

  const { TeaserTimelineTemplate } = await import(
    '../../molecules/teaser-timeline/teaser-timeline'
  );
  const { Presentation } = await import(
    '../../../shared/js/modules/presentation'
  );

  timelines.forEach(timeline => {
    const uniqueStr = `${Math.floor(
      Math.random() * Math.floor(Math.random() * Date.now())
    )}`;
    const timelineNav = timeline.querySelector('.timeline__nav');
    const timelineSlides = timeline.querySelectorAll('.timeline__tabpanel');
    const navTimeline = timelineNav.querySelector('.nav-timeline');
    const navTimelineTab = navTimeline.querySelectorAll('.nav-timeline__tab');
    const initialIndex = (() => {
      const ariaSelectIndex = Array.from(navTimelineTab).findIndex(
        button => button.getAttribute('aria-selected') === 'true'
      );
      return ariaSelectIndex < 0 ? 0 : ariaSelectIndex;
    })();
    let timelineInstanceIsInitiated = false;

    // Init timeline
    const timelineInstance = new Presentation({
      slideSources: Array.from(navTimelineTab).map(tab => tab.dataset.json),
      slideElements: Array.from(timelineSlides),
      initialSlideIndex: initialIndex,
      pauseMediaContent() {
        // const currentSlide = this.slideContent[this.currentSlide];
        console.log(this.slideElements);
        const videos = document.querySelectorAll('.timeline__content iframe');
        console.log(videos);
        if (!videos.length) return;
        videos.forEach(video => {
          if (video.hasAttribute('src')) {
            video.removeAttribute('src');
            setTimeout(() => {
              video.setAttribute('src', video.dataset.src);
            }, 1000);
          }
        });
      },
      onAfterWriteSlide() {
        const currentSlide = this.slideContent[this.currentSlide];

        // init consent overlays
        const consentOverlays =
          currentSlide.querySelectorAll('.consent-overlay');
        consentOverlays.length && initConsentOverlays();

        // init lightboxes
        const lightboxElements = document.querySelectorAll(
          '.teaser-timeline__lightbox'
        );
        lightboxElements.length &&
          lightboxElements.forEach(lightboxEl => {
            const toggles = lightboxEl.querySelectorAll(
              '.teaser-timeline__lightbox-toggle'
            );
            const lightbox = new Lightbox({
              ...{ gallery: lightboxEl, children: toggles },
              ...config,
            });
            lightbox.init();
            fixCounter(lightbox);
          });
      },
      slideContentTemplate: TeaserTimelineTemplate,
      loadingContentTemplate: () => {
        return `
        <div class='timeline__loading'>
          <div class='timeline__loading-text'>
            ${labels[lang].loading}
          </div>
        </div>`;
      },
      contentWrapperAsList: true,
      contentWrapperClass: 'timeline__list',
    });

    timelineInstance.init();

    timelineInstances.push(timelineInstance);

    // Init nav tabs
    const tabsInstance = new Tabs({
      tablist: navTimeline,
      tabButtons: navTimelineTab,
      tabPanels: timelineSlides,
      initialTabIndex: initialIndex,
      onBeforeSelect: obj => {
        if (timelineInstanceIsInitiated) timelineInstance.pauseMediaContent();
      },
      onAfterSelect: obj => {
        if (timelineInstanceIsInitiated)
          timelineInstance.loadSlide(obj.currentTabIndex);
        Bus.broadcast('timeline_select', {
          currentIndex: obj.currentTabIndex,
        });
      },
    });

    tabsInstance.init();
    tabsInstances.push(tabsInstance);

    timelineInstanceIsInitiated = true;

    // Listen for slide changes
    Bus.subscribe(
      'slider_change',
      `NavTimeline-SliderChange-${uniqueStr}`,
      obj => {
        if (obj.isNavTimeline) {
          tabsInstance.selectTab(obj.currentIndex);
        }
      }
    );

    // Init nav slider
    // new Slider({
    //   el: navTimeline,
    //   userConfig: { initialSlide: initialIndex },
    // }).init();
  });
};

initTimelines();
